import React from 'react';
import loader from '../../assets/images/loader.gif';
import '../../assets/css/loader.css';

const Loader = ({show}) => {
    return(
    <>
     {
            !show &&
            <div className="loader-overlay">
              <div className="loader-text"><img src= {loader} alt='loader'/></div>
            </div>
     }
    </>
    );
}

export default Loader;